<template>
  <div>
    <!-- MODAL DELETE CONFIRMATION -->
    <div class="modal fade" :id="id" tabindex="-1" :aria-labelledby="id" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <p class="modal-title typography-headline-md fw-500" :id="id">{{ label }}</p>
            <button type="button" class="btn-close img-logo" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body py-4">
            <p class="subtitle-1">Are you sure you want to delete {{ name }}?</p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-default-outline ripple ripple-dark" data-bs-dismiss="modal">Cancel</button>
            <button type="button" class="btn btn-danger" data-bs-dismiss="modal" @click="deleteItem">{{ label }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'label',
    'id',
    'value',
    'name',
  ],
  methods: {
    deleteItem(){
      this.$emit('deleteItem')
    }
  }
}
</script>